const GetAllTeams_query = `
query($clientId: Int!) {
  allTeams(clientId: $clientId) {
    teamId
    teamUuid
    name
    desc
    deletable
    clientId {
        name

      }
    createDate
    updateDate   
  }
}
`;

const CreateTeam_mutate = `
    mutation createTeam(
      $name: String!
      $clientId: Int!
      $desc: String     
      ) {
      createTeam(
        name: $name,
        clientId: $clientId,
        desc: $desc,
         ) {
        team
        {
          teamId
          teamUuid
          clientId
            {
              name
            }
          
          name
          desc
          createDate
          updateDate
                
        }
      }
    }
`;

const GetTeamDataByName_query = `
    query( $name: String! , $clientId: Int! , $teamUuid: String)
    {
      getTeamDataByName(name:$name,clientId:$clientId,teamUuid:$teamUuid)
      {
          teamId
          teamUuid
          name  
          desc        
          clientId
            {
              clientId
              name
            }
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const GetTeamDataById_query = `
    query( $teamUuid: String!)
    {
      getTeamDataById(teamUuid:$teamUuid)
      {
          teamId
          teamUuid
          name  
          desc        
          clientId
            {
              clientId
              name
            }
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const EditTeam_mutate = `
    mutation editTeam(      
      $name: String!
      $teamUuid: String!
      $desc: String          
      ) {
      editTeam(        
        name: $name,
        teamUuid: $teamUuid
        desc: $desc
        ) {
        team
          {
            teamId
            teamUuid
            clientId
              {
                name
              }
            
            name
            desc
            createDate
            updateDate
          }
      }
    }
`;
const DeleteTeam_mutate = `
    mutation delete_team($teamId: Int!) {
      deleteTeam(teamId: $teamId) {
        response
      }
    }
`;

module.exports = {
  GET_ALL_TEAMS_QUERY: GetAllTeams_query, 
  CREATE_TEAM_MUTATION: CreateTeam_mutate,
  GET_TEAM_DATA_BY_NAME : GetTeamDataByName_query,
  GET_TEAM_DATA_BY_ID :  GetTeamDataById_query,
  EDIT_TEAM_MUTATION: EditTeam_mutate,
  DELETE_TEAM_MUTATION: DeleteTeam_mutate,
};
